<template>
	<div class="py-4 mx-2 d-flex align-start space-between fontS14 wrap">
		<div class="big mx-3 mb-1">
			<h3
				class="uppercase fontS14 fontAvenirBold ml-2"
				:style="`color: ${globalColors.primary}`"
			>Resumen de tu pedido</h3>
			<address-data/>
			<billing-data/>
		</div>
		<div class="shoping-summary">
			<div class="card-summary mb-3 py-1">
				<h3 class="txt-center">Resumen de Compra</h3>
				<div class="summary-amounts">
					<p class="subtotal d-flex space-between align-center mx-3 fontAvenirBold">
						<span>Subtotal</span>
						<span>{{getCurrencySymbol}} {{orderSummaryInfo.subtotal | priceFormat}}</span>
					</p>
					<p class="delivery d-flex space-between align-center mx-3">
						<span>Envio</span>
						<span>{{getCurrencySymbol}} {{orderSummaryInfo.costShipping | priceFormat}}</span>
					</p>
				</div>
				<h3 class="d-flex align-center space-between mx-3">
					<span>Total</span>
					<span>{{getCurrencySymbol}} {{orderSummaryInfo.total | priceFormat}}</span>
				</h3>
			</div>
			<div class="card-payment">
				<h3 class="txt-center">Método de pago</h3>
				<div class="summary-payment">
					<p class="txt-center my-2">{{wayPayment}}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import lib from '@/helpers/lib';

function beforeDestroy() {
	this.$store.commit('SET_SHIPPING_COST', null);
}

function wayPayment() {
	return lib.getDeeper('wayPayment.name')(this.orderSummaryInfo);
}

export default {
	name: 'summary-order',
	beforeDestroy,
	components: {
		addressData: () => import('@/components/summary/addressData'),
		billingData: () => import('@/components/summary/billingData'),
	},
	computed: {
		...mapGetters([
			'getCurrencySymbol',
			'orderSummaryInfo',
		]),
		wayPayment,
	},
};
</script>
<style lang="scss" scoped>
	.card-summary,
	.card-payment {
		background-color: color(grayMedium);
		border: 0.1rem solid color(lineGrey);
		border-radius: 1.1rem;
		width: 30rem;
	}

	.summary-amounts {
		border-bottom: 0.1rem solid color(lineGrey);
		border-top: 0.1rem solid color(lineGrey);
	}

	.subtotal {
		color: color(spaceBold);
	}

	.delivery {
		color: color(textProduct);
	}

	.summary-payment {
		border-top: 0.1rem solid color(lineGrey);
	}

	.big {
		flex: 1 1 55%;
	}

	.shoping-summary {
		flex: 1 1 20%;

		@media (max-width: 600px) {
			margin: 0 auto;
		}
	}
</style>




// WEBPACK FOOTER //
// summaryOrder.vue?601818ee